import { get as _get } from 'lodash';
import browserStorage from 'components/consumer/browser-storage';
import { fabricObject } from '../fabric-filter/utils';

const URL_PREFIX = 'https://joybird2.imgix.net/fabric-swatches/t1/';
export const returnDisplayFabricList = fabricsList => {
  const displayFabricList = fabricsList.reduce(
    (acc, fabric) => [...acc, fabricObject(fabric)],
    []
  );

  return displayFabricList;
};

export const removeEmptyFilters = (filters = {}) => {
  let finalFilters = {};
  const filterKeys = Object.keys(filters);

  finalFilters = filterKeys.reduce((acc, filterKey) => {
    if (filters[filterKey] !== 0 && filters[filterKey] !== '') {
      acc[filterKey] = filters[filterKey];
    }
    return acc;
  }, {});
  return finalFilters;
};

export const getCustomPropsHelper = (
  selectedGridItem,
  pathname = null,
  isFavorite,
  isUserLoggedIn,
  numOfFavFabrics,
  itemGalleryData = {},
  isMobile
) => {
  if (!selectedGridItem) {
    return {};
  }

  const selectedType = _get(selectedGridItem, 'option.type', null);
  const selectedFabricName = _get(selectedGridItem, 'footerTitle.name', null);

  const { img_prefix = '', img_suffixes = '' } = itemGalleryData;
  const img_suffixesList = img_suffixes.length ? img_suffixes.split(',') : null;
  const images = [];
  for (let i = 0; i < img_suffixesList?.length; i++) {
    images.push(
      URL_PREFIX.concat(img_prefix, `-t1-${img_suffixesList[i]}.jpg`)
    );
  }
  let shopThisTextLink = _get(selectedGridItem, 'linkButton.link', null);
  shopThisTextLink =
    shopThisTextLink && !shopThisTextLink.startsWith('/')
      ? `/${shopThisTextLink}`
      : shopThisTextLink;

  return {
    selectedItemType: selectedType,
    selectedItemName: selectedFabricName,
    selectedItemMaterial: selectedFabricName,
    selectedItemGroupMaterial: _get(selectedGridItem, 'option.material', ''),
    selectedItemGroupCleaningCode: _get(
      selectedGridItem,
      'option.cleaning_code',
      ''
    ),
    selectedItemTier: _get(selectedGridItem, 'option.tier', ''),
    isPetAndKidFriendly: _get(selectedGridItem, 'option.pet_friendly', false),
    isSustainable: _get(selectedGridItem, 'option.sustainable_fabric', false),
    customerPhotosUrl:
      selectedType && selectedFabricName
        ? `/customer-photos?materialOption=${selectedFabricName}`
        : null,
    shopThisText: 'Shop this Color',
    shopThisTextLink,
    shopThisTextClick: () => {
      if (!isMobile) {
        if (selectedGridItem) {
          if (pathname && pathname.includes('swatches/')) {
            browserStorage().setItem(
              'selectedMaterialSwatchItem',
              JSON.stringify(selectedGridItem)
            );
          }
        } else {
          browserStorage().removeItem('selectedMaterialSwatchItem');
        }
      }
    },
    selectedItemDescription: _get(selectedGridItem, 'subTitle.name', null),
    isFavorite: !!isFavorite,
    isUserLoggedIn,
    numOfFavFabrics,
    images: images.length > 0 ? images : null,
  };
};
